import { designVariables } from "@studio3t/design-variables";
import { GenericLink } from "@studio3t/generic-components";
import styled from "styled-components";

const HEADING = designVariables.type.heading;
const SEMANTIC = designVariables.ui.semantic;
const NEUTRALS = designVariables.primitives.neutrals;

// Shared chrome for the dashboard hero cards (Figma "Card2", node
// 14879-250781): a 70px header band, an optional 70px grey footer band, and
// 40px horizontal gutters — semantic/spacingxl, which the installed
// design-variables package doesn't expose yet.
export const GUTTER = 40;
export const CARD_HEADER_HEIGHT = 70;

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  gap: ${SEMANTIC.spacings}px;
  height: ${CARD_HEADER_HEIGHT}px;
  padding: 0 ${GUTTER}px;
  flex-shrink: 0;
  background: ${(props) => props.theme.semanticAppBackground};
`;

export const CardTitle = styled.h2`
  flex: 1;
  min-width: 0;
  margin: 0;
  font-size: ${HEADING.h4.fontSize}px;
  font-weight: ${HEADING.h4.fontWeight};
  line-height: 1.2;
  text-transform: uppercase;
  color: ${(props) => props.theme.semanticTextHeading};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

// Figma semantic/greybackground (#fafafa = neutrals/10); the app ships the
// light theme only, so the primitive stands in for the missing theme token.
// min-height instead of a fixed height: on a narrow card the link and
// the action wrap into two rows instead of skewing out of the band.
export const CardFooter = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: ${SEMANTIC.spacings}px;
  min-height: ${CARD_HEADER_HEIGHT}px;
  padding: ${SEMANTIC.spacings}px ${GUTTER}px;
  box-sizing: border-box;
  flex-shrink: 0;
  background: ${NEUTRALS[10]};
`;

// GenericLink underlines only on hover; the card footer links are underlined
// at rest per the design (Figma 14879-250797).
export const FooterLink = styled(GenericLink)`
  text-decoration: underline;
`;

export const DOCS_URL = "https://docs.3t.io/docs/3tl-bridge";

/** A card with nothing to show says so where its content would start
 *  (Figma 16102-26437): one italic line in the light ink, flush with the
 *  gutter, with the card keeping its height around it. */
export const EmptyMessage = styled.p`
  margin: 0;
  padding: 0 ${GUTTER}px;
  font-size: ${designVariables.type.singleLine.small.regular.fontSize}px;
  font-style: italic;
  line-height: 1.2;
  color: ${(props) => props.theme.semanticTextLight};
`;
